import { useIsMounted, useUnmountEffect } from "@react-hookz/web";
import { useRef, useCallback } from "react";

export interface UseRequestAnimationFrameResult {
    cancel: () => void;
    raf: (fn: () => void) => void;
}

export const useRequestAnimationFrame = (): UseRequestAnimationFrameResult => {
    const rafIdRef = useRef(0);
    const cancel = useCallback(() => {
        cancelAnimationFrame(rafIdRef.current);
    }, []);

    const isMounted = useIsMounted();

    const raf = useCallback(
        (callback: () => void) => {
            cancel();
            rafIdRef.current = requestAnimationFrame(() => {
                if (isMounted()) {
                    callback();
                }
            });
        },
        [isMounted, cancel]
    );

    useUnmountEffect(cancel);

    return {
        cancel,
        raf,
    };
};
